export const all = (...args) => {
  args.forEach(arg => typeof arg === 'function' && arg())
}
